import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';

@Component({
  selector: 'app-bussinesshours',
  templateUrl: './bussinesshours.component.html',
  styleUrls: ['./bussinesshours.component.css'],
})

export class BussinesshoursComponent{

data:any;
  backendUrl:any;
  sel_id:any;
  loadingnew = false;
  loading = false;
  complexForm:FormGroup;
  model: any = {};
  id:number;
  branchID:any;
  hoursId:any = [];

constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.

      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.

    })

  }
  ngOnInit(){

  function timeFormat(timeVal) {
      var timeStr = timeVal.toString();
      timeStr = timeVal.split(":");
      return timeStr[0]+':'+timeStr[1];
  }

  let url=window.location.hostname;
    // if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}
    // else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;

     var sql1="SELECT * FROM fb_branches  where restaurant_id="+restaurant_id;
        this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql1}))
          .subscribe(data => {
            this.branchID = data[0].branch_id;
            let sql="SELECT * FROM fb_business_hours where branch_id="+this.branchID; 
            let headers = new Headers ({  'Content-Type': 'application/json' });
            let options = new RequestOptions({ headers: headers, method: "post" });

          this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql}))
            .subscribe(data2 => {
            if(data2.length > 0) {
            if(data2[0].status == 1){
              $('#status0').iCheck('check');
            }else{
              $('#status0').iCheck('uncheck');
            }
            this.model.status0 = data2[0].status;
            this.model.open_time0 = timeFormat(data2[0].open_time);
            this.model.close_time0 = timeFormat(data2[0].close_time);
            this.hoursId.push(data2[0].id);

            if(data2[1].status == 1){
              $('#status1').iCheck('check');
            }else{
              $('#status1').iCheck('uncheck');
            }
            this.model.status1 = data2[1].status;
            this.model.open_time1 = timeFormat(data2[1].open_time);
            this.model.close_time1 = timeFormat(data2[1].close_time);
            this.hoursId.push(data2[1].id);

            if(data2[2].status == 1){
              $('#status2').iCheck('check');
            }else{
              $('#status2').iCheck('uncheck');
            }
            this.model.status2 = data2[2].status;
            this.model.open_time2 = timeFormat(data2[2].open_time);
            this.model.close_time2 = timeFormat(data2[2].close_time);
            this.hoursId.push(data2[2].id);

            if(data2[3].status == 1){
              $('#status3').iCheck('check');
            }else{
              $('#status3').iCheck('uncheck');
            }
            this.model.status3 = data2[3].status;
            this.model.open_time3 = timeFormat(data2[3].open_time);
            this.model.close_time3 = timeFormat(data2[3].close_time);
            this.hoursId.push(data2[3].id);

            if(data2[4].status == 1){
              $('#status4').iCheck('check');
            }else{
              $('#status4').iCheck('uncheck');
            }
            this.model.status4 = data2[4].status;
            this.model.open_time4 = timeFormat(data2[4].open_time);
            this.model.close_time4 = timeFormat(data2[4].close_time);
            this.hoursId.push(data2[4].id);

            if(data2[5].status == 1){
              $('#status5').iCheck('check');
            }else{
              $('#status5').iCheck('uncheck');
            }
            this.model.status5 = data2[5].status;
            this.model.open_time5 = timeFormat(data2[5].open_time);
            this.model.close_time5 = timeFormat(data2[5].close_time);
            this.hoursId.push(data2[5].id);

            if(data2[6].status == 1){
              $('#status6').iCheck('check');
            }else{
              $('#status6').iCheck('uncheck');
            }
            this.model.status6 = data2[6].status;
            this.model.open_time6 = timeFormat(data2[6].open_time);
            this.model.close_time6 = timeFormat(data2[6].close_time);
            this.hoursId.push(data2[6].id);
            }
        });
          });
    
     

$(document).ready(function(){

$("input").on("keypress", function(e) {
    if (e.which === 32 && !this.value.length)
        e.preventDefault();
});
$.validator.addMethod("clsRequired", function(value, element) { 
  return value == '' || value.trim().length != 0; 
}, "This Field is required");
$.validator.addMethod("biz_open1", function(value, element){
    var id = element.id;
    var last_char = id.slice(-1);
    var close_time = $('#close_time'+last_char).val();
     if (value.toString() > close_time.toString()) {
         return false;
     }else{
     return true;
     };
}, "From hours should not be greater than to hours");

 $.validator.addMethod("biz_close1", function(value, element){
    var id = element.id;
    var last_char = id.slice(-1);
    var close_time = $('#open_time'+last_char).val();
     if (value.toString() < close_time.toString()) {
         return false;
     }else{
     return true;
     };
}, "To hours should be greater than From hours");

$('#business_hours').validate({
        errorPlacement: function(error, element) {
          if (element.type == 'checkbox') {
            error.appendTo(element.parent());
          }
          else {
            error.insertAfter(element);
          }
        }

      })
$('.chkb').on('ifChecked', function (event){
          var id = $(this).attr('id');
          var last_char = id.slice(-1);
          $('#open_time'+last_char).rules('add', {
            required: true,
            messages: {
              required:  "This Field is required",
              }
          });
          $('#close_time'+last_char).rules('add', {
            required: true,
            messages: {
              required:  "This Field is required",
              }
          });
      });
$('.chkb').on('ifUnchecked', function (event){
          var id = $(this).attr('id');
          var last_char = id.slice(-1);
          $('#open_time'+last_char).rules('add', {
            required: false,
            messages: {
              required:  "This Field is required",
              }
          });
          $('#close_time'+last_char).rules('add', {
            required: false,
            messages: {
              required:  "This Field is required",
              }
          });
      });

      $('.tagsinput').tagsinput({
        tagClass: 'label label-primary'
      });
      $('.clockpicker').clockpicker()
        .find('input').change(function(){
          // TODO: time changed
          console.log(this.value);
        });
      $('#fromtime').clockpicker()
        .find('input').change(function(){
          // TODO: time changed
          console.log(this.value);
        });

      var totimeval;
      var fromtimeval;
      var totime = $('#totime');
      totime.clockpicker({
        autoclose: true
      }).find('input').change(function(){
        // TODO: time changed
        totimeval = this.value;
      });

      var fromtime = $('#fromtime');
      fromtime.clockpicker({
        autoclose: true
      }).find('input').change(function(){
        // TODO: time changed
        fromtimeval = this.value;
      });


      $('.i-checks').iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green',
      });

      $('.checkall').on('ifChecked', function (event){
        var fromtimeVal = $('#open_time0').val();
        var totimeVal = $('#close_time0').val();
        if(fromtimeVal == '' || totimeVal == ''){
        setTimeout(function() {
            $('.checkall').iCheck('uncheck');
        },100);     
        $('.danger').text('');   
        $('.danger').append('This Field is required.');        
        return false;
        }else {
          $('.danger').text('');
          $(this).closest("input").attr('checked', true);
         // $('.clockpicker').clockpicker('remove');
          //$('.fromtime').parent().removeClass('clockpicker');
          //$('.totime').parent().removeClass('clockpicker');
          $('.fromtime').val(fromtimeVal);
          $('.totime').val(totimeVal);
          $('.chkb').iCheck('check');
        }        
      });
      $('.checkall').on('ifUnchecked', function (event) {
        $(this).closest("input").attr('checked', false);
        $('.fromtime').parent().addClass('clockpicker');
        $('.totime').parent().addClass('clockpicker');
        $('.fromtime').val("");
        $('.totime').val("");
        $('.clockpicker').clockpicker({autoclose:true},'init');
        $('.chkb').each(function(index) {
          if(index != 0) {
          $(this).iCheck('uncheck');
          }
        })
      });

      $('.remove_err').blur(function(){
          $('#err').text('');
      });
      $('.remove_err1').blur(function(){
          $('#err1').text('');
      });
            });
           
  }

  save_hours()
  {
    var i =0;
    $('.biz_open').each(function(index) {
    var frTime = $('#open_time'+index).val();
    var clTime = $('#close_time'+index).val();
      if($(this).val() == '' || (frTime == "00:00" && clTime == "00:00")) {
        i++;
      }
    });
    if(i == 7) {
      alert('please fill atleast one from and to time');
      return false;
    }
    let dayData = '';
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id=currentUser.restaurant_id;
    if($('#business_hours').valid())
    {
      var l = Ladda.create( document.querySelector( '#save_hours') );
      l.start();
      for(var i = 0; i < 7; i++){
      if($('#status'+i).is(":checked")){
        var statusVal = 1;
      }else {
        var statusVal = 0;
      }
      let userdata = {
        open_time : $('#open_time'+i).val(),
        close_time : $('#close_time'+i).val(),
        day : i,
        status : statusVal,
        branch_id : this.branchID
      };
      
      if(this.hoursId.length > 0){
        let sql="update fb_business_hours set ? where branch_id="+this.branchID+" AND id="+this.hoursId[i];
        this.userService.insert(this.backendUrl,JSON.stringify({'query': sql,'data':userdata}))
          .subscribe(data => {
            l.stop();
            this.ngOnInit();
            $('#success').html('Bussiness hours is updated successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }
      else{
        if(this.branchID == '' || this.branchID == undefined) {
          alert('Please fill contact details first.');
          l.stop();
          return false;
        }else {
        let sql="insert into fb_business_hours SET ?"
        this.userService.insert(this.backendUrl,({'query': sql,'data':userdata}))
          .subscribe(data => {
            let id = data.id;
            l.stop(); 
            this.ngOnInit(); 
           $('#success').html('Bussiness hours is saved successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);          
          });
          }
      }
      }
//this.router.navigate(['branches']);
    }
  }
}




// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/bussinesshours/bussinesshours.component.ts